<template>
    <div class="availability-status">
        Availability: {{full_product_json.is_in_stock}}
    </div>
    <div  :class="['imprint-app-wrapper',isComda ? 'comda' : 'mlp']">
        <div class="imprint-nav-wrapper">
            <div v-if="applicationType !== 'calendar_single'" class="step-info-header">
                <ul class="step-info-header__list c-list">

                    <li class="c-list__item" :class="[step === 1 ? ['c-list__item-active', customBackground] : '' ]">
                        <div>
                            Step 1
                            <span v-if="step == 1">: Choose Imprint Method</span>
                        </div>
                    </li>
                    <li v-if="store.application_type == 'default'" class="c-list__item" :class="[step === 2 ? ['c-list__item-active', customBackground] : '']">
                        <div>
                            Step 2
                            <span v-if="step == 2">: Product  {{ getColorText() }} and Quantity</span>
                        </div>
                    </li>
                    <li v-if="store.isCustomBundlePage" class="c-list__item" :class="[step >= maxStep ? ['c-list__item-active', customBackground] : '']">
                        Step {{ maxStep }}
                        <span v-if="step >= maxStep">: Customize your Product</span>
                    </li>
                    <li v-if="!store.isCustomBundlePage" class="c-list__item" :class="[step >= 3 ? ['c-list__item-active', customBackground] : '']">
                        <div>
                            Step {{ maxStep }}
                            <span v-if="step >= 3">: Customize your Product</span>
                        </div>
                    </li>

                </ul>
            </div>

            <div v-if="isComda && applicationType == 'calendar_single'" class="step-info-header">
                <ul class="step-info-header__list c-list calendar-bundle">
                    <li class="c-list__item" :class="[step === 1 ? ['c-list__item-active', customBackground] : '' ]">
                        <div>
                            Step 1
                            <span v-if="step == 1">: Choose Imprint Method</span>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="imprint-step-content">
                <template v-if="showTextCard">
                    <CTextCard
                        :cStep="step"
                        :textCardTitle="stepInfo[step-1].textCardTitle"
                        :textCardBody="stepInfo[step-1].textCardBody"
                        :additionalText="stepInfo[step-1].additionalText"
                        @back-to-parent="backToParent"
                        :isCustomBundlePage = false
                    />
                </template>
                <template v-if="store.isCustomBundlePage">
                    <CTextCard
                        :cStep="step"
                        :textCardTitle="calendarStepInfo[0].textCardTitle ? calendarStepInfo[0].textCardTitle : ''"
                        :textCardBody="calendarStepInfo[0].textCardBody"
                        :additionalText="calendarStepInfo[0].additionalText"
                        @back-to-parent="backToParent"
                        :isCustomBundlePage = true
                    />
                </template>

                <template v-if="step == 1">
                    <ImprintTabs
                        @inited-qty-increment="setIncrementMinOrderQty"
                        @imprint-tier-seted="afterSetImprintTier"
                        :getColorText="getColorText"
                        :applicationType="applicationType"
                        :textCardTitle="calendarStepInfo[0].textCardTitle ? calendarStepInfo[0].textCardTitle : ''"
                    >
                    </ImprintTabs>
                  <div class="product-promo-section promo-block" v-if="applicationType != 'calendar_single' && !isComda && !store.isCustomBundlePage">
                    <div class="promo-label">
                      <span>pricing made easy!</span>
                    </div>
                    <div class="promo-text">
                    <span>
                        All-in pricing and no hidden fees.<br> We’ve made it <span class="green-bold">easy</span> for you to fit any budget!
                    </span>
                    </div>
                  </div>
                </template>

                <template v-if="step == 2 && maxStep !== 2">
                    <template v-for="(line, index) in store.colorSizeLines[store.imprintKey]" :key="index">
                        <ColorSizePickerComponent
                            :line-index="index"
                            :removed-line="removedLineIndex"
                            @color-loaded="afterLoadedColors"
                            :getColorText="getColorText"
                        >
                        </ColorSizePickerComponent>
                    </template>
                    <div
                        v-if="store.colorSizeLines[store.imprintKey].length < maxColorCount"
                        :class="['imprint-message__add add-color', customColor]"
                        :style="step === 2 ? '' : ''"
                        @click="addNewColorSizeLine"
                    >
                        <span class="plus">+</span>
                        <span>Add a New {{getColorText()}}</span>
                    </div>
                    <p style="border-bottom: 2px solid rgb(215, 215, 215); margin: 0;"></p>
                    <PriceMatrixComponent :applicationType="applicationType" :isSpecial="checkIsSpecial"/>
                </template>

                <template v-if="isImprintStepShow(step)">
                    <div class="btns-wrapper btns--vertical">
                        <button :class="['btns__item', customBackgroundHover]" @click="startNewImprint">Start New Imprint</button>
                        <button :class="['btns__item', customBackgroundHover]" @click="sendUsYourArtworkAfterOrdering">Send Us Your Artwork After Ordering</button>
                        <p>Are you a Returning Customer?</p>
                        <button :class="['btns__item', customBackgroundHover]" @click="useMyPreviousArtwork">Use My Previous Artwork</button>
                    </div>
                </template>

                <!--     Start STEP 4    -->
                <template v-if="step == 4">
                    <NewImprintCard
                        @step-four-change="afterNewImprintChanged"
                        :validation="validationResult"
                        :getColorText="getColorText"
                    >
                    </NewImprintCard>
                </template>

                <!--     END STEP 4    -->

                <!--     START STEP 5    -->
                <template v-if="step == 5">
                    <div class="start-new-imprint">

                        <ImprintLocation :c-step="step"></ImprintLocation>

                        <div class="start-new-imprint__section imprint-textarea">
                            <label class="start-new-imprint__label" for="imprint-types">Special Instruction</label>
                            <div id="imprint-types" class="start-new-imprint__textare">
                                <textarea
                                    class="c-full-width"
                                    name=""
                                    id="step-5"
                                    cols="30"
                                    rows="10"
                                    :value="this.store.selectedLastStep[this.store.imprintKey].special_instruction ? this.store.selectedLastStep[this.store.imprintKey].special_instruction : specialInstruction"
                                    @change="setSpecialInstruction($event.target.value)"
                                >
                            </textarea>
                            </div>
                        </div>
                    </div>
                </template>
                <!--     END STEP 5    -->


                <!--     START STEP 6    -->
                <template v-if="step == 6">
                    <div class="start-new-imprint">

                        <ImprintLocation :c-step="step"></ImprintLocation>

                        <div class="start-new-imprint__section imprint-textarea">
                            <label :class="['start-new-imprint__label', customFont]" for="imprint-types">Special Instruction</label>
                            <div id="imprint-types" class="start-new-imprint__textare">
                                <textarea
                                class="c-full-width"
                                    name=""
                                    id="step-6"
                                    cols="30"
                                    rows="10"
                                    :value="this.store.selectedLastStep[this.store.imprintKey].special_instruction ? this.store.selectedLastStep[this.store.imprintKey].special_instruction : specialInstruction"
                                    @change="setSpecialInstruction($event.target.value)"
                                >
                                </textarea>
                            </div>
                        </div>
                    </div>
                </template>
                <!--     END STEP 6    -->

                <div class="imprint-bottom-info-text" v-if="step < 3 && !store.isCustomBundlePage && store.application_type != 'calendar' && store.application_type != 'calendar_single'">
                    <CTextCardRequrenmentRules :c-step="step" :tab-name="this.store.imprintKey"></CTextCardRequrenmentRules>
                </div>
                <div class="imprint-line" v-if="step == 2 && store.isCustomBundlePage"></div>
            </div>

            <div v-if="applicationType !== 'calendar_single'" class="step-nav">
                <ul class="step-nav__list step-nav__list--imprint" :class="store.totalSizesQty < store.inputProductData.minOrderQty && step == 2 ? 'imprint-nav-next--disabled' : ''">
                    <li v-if="isComda && step ===1">
                        <div class="modal-btn" @click="showModal = true">
                            How to order with COMDA.COM
                        </div>
                    </li>

                    <li  class="step-nav__item" :class="[step !==1 ? 'step-nav__item--prev' : '', customColorBefore]">
                        <div class="c-btn c-btn--imprint-nav c-btn--imprint-nav-left" @click ="prev" @keyup.enter="prev" >
                            <span :class="['imprint-nav__text nav-step', 'imprint-nav__text--main', customColor]"
                                  v-if="step !==1"
                                  tabindex="0"
                                  @click="$event.target.blur()"
                                  @keyup.enter="$event.target.blur()">
                                Previous Step
                            </span>
                            <template v-if="!store.isCustomBundlePage">
                                <span :class="['imprint-nav__text', 'imprint-nav__text--sub', customColor]"
                                      v-if="step !==1">
                                    {{ stepInfo[step-1].navPrevSubText }}
                                </span>
                            </template>
                            <template v-if="store.isCustomBundlePage">
                                <span :class="['imprint-nav__text', 'imprint-nav__text--sub', customColor]"
                                      v-if="step !==1">
                                    {{ calendarStepInfo[0].navPrevSubText }}
                                </span>
                            </template>
                        </div>
                    </li>

                    <li v-if="step < 3 && step != maxStep" class="step-nav__item" :class="[step < 3 ? 'step-nav__item--next' : '', customColorAfter]">
                        <div
                            class="c-btn c-btn--imprint-nav c-btn--imprint-nav-right"
                            :class="(store.totalSizesQty < store.inputProductData.minOrderQty && step == 2) || (this.store.qtyError && step == 2 ) ? 'c-btn--imprint-nav--disabled' : ''"
                            @click="next"
                            @keyup.enter="next"
                        >
                                <span v-if="step < 3 && step != maxStep"
                                      :class="['imprint-nav__text nav-step', 'imprint-nav__text--main', customColor]"
                                      tabindex="0" @click="$event.target.blur()"
                                      @keyup.enter="$event.target.blur()">
                                    Next Step
                                </span>
                                <template v-if="!store.isCustomBundlePage">
                                    <span v-if="step < 3 && step != maxStep"
                                          :class="['imprint-nav__text', 'imprint-nav__text--sub', customColor]">
                                        {{ stepInfo[step-1].navNextSubText }}
                                    </span>
                                </template>
                                <template v-if="store.isCustomBundlePage">
                                    <span v-if="step < 3 && step != maxStep"
                                          :class="['imprint-nav__text', 'imprint-nav__text--sub', customColor]">
                                        {{  calendarStepInfo[0].navNextSubText }}
                                    </span>
                                </template>
                        </div>
                    </li>

                    <!--template v-if="step >= 4"          <li class="step-nav__item" :class="step == 3 ? 'step-nav__item--add-to-cart' : ''">-->
                    <template v-if="step >= 4">
                        <li class="step-nav__item" :class="step == 3 ? 'step-nav__item--add-to-cart' : ''">
                            <div class="c-btn-addtocart-wrap">
                                <!--p style="margin-top: 20px; font-size: 16px;" @click="addToCartOrig"> Add to cart Test </p-->
                                <button
                                    class="c-btn c-btn--add-to-cart"
                                    :disabled="this.store.isCustomBundlePage && this.bundleProductCleared ? 'disabled' : false"
                                    :class="[isAddToCartDisabled() ? 'btn-disabled' : '', customBackground, customBackgroundHover]"
                                    @click="addToCart">
                                        Add to cart
                                </button>
                            </div>
                        </li>
                    </template>
                </ul>
            </div>
        </div>

        <imprintAppSummary
            :new-imprint="newImprint"
            :new-tier-data="imprintTierData"
            :step="step"
            :application-type="store.application_type"
        >
        </imprintAppSummary>
    </div>

    <transition v-if="showModal">
        <div class="modal-mask">
            <div class="modal-container">
                <img :src="imageHowToOrder" alt="">
                <div class="modal-close-btn" @click="showModal = false">X</div>
            </div>
        </div>
    </transition>
</template>

<script>

import CTextCard from './CTextCard.vue';
import CTextCardRequrenmentRules from './CTextCardRequrenmentRules.vue';
import ImprintTabs from './ImprintTabs.vue';
import ColorSizePickerComponent from './ColorSizePickerComponent.vue';
import NewImprintCard from './NewImprintCard.vue';
import imprintAppSummary from './imprintAppSummary.vue';
import ImprintLocation from './ImprintLocation.vue';
import PriceMatrixComponent from "./PriceMatrixComponent.vue";
import axios from 'axios';
import { store } from './store.js';
import imageHowToOrder from '../assets/how_to_order_image.png';

export default {

    components: {
        CTextCard,
        ImprintTabs,
        ColorSizePickerComponent,
        NewImprintCard,
        CTextCardRequrenmentRules,
        imprintAppSummary,
        ImprintLocation,
        PriceMatrixComponent
    },
    data() {
        return {
            imageHowToOrder,
            showModal: false,
            step: 1,
            stepsDebugMode: true,
            isComda: false,
            specialInstruction: '',
            stepInfo: [
                {
                    id: 1,
                    navNextSubText: 'Choose Product ' + this.getColorText() + ' and Quantity',
                    navPrevSubText: '',
                    infoSubText: '',
                    textCardTitle: 'Choose Imprint Method',
                    textCardBody: 'Choose the imprint method that you would like your product to be customized with. The price grid below will update based on which imprint method is selected.',
                    additionalText: ''
                },
                {
                    id: 2,
                    navNextSubText: 'Customize your Product',
                    navPrevSubText: 'Choose your Imprint Method',
                    infoSubText: '',
                    textCardTitle: 'Choose Product ' + this.getColorText() + ' and Quantity',
                    textCardBody: 'Choose the product ' + this.getColorText(true) +'  and quantity that you wish to purchase. If you would like to choose more than one ' +  this.getColorText(true) + '  click + Add a New ' +  this.getColorText() + '',
                    additionalText: ''
                },
                {
                    id: 3,
                    navNextSubText: '',
                    navPrevSubText: 'Choose Product ' + this.getColorText() + ' and Quantity',
                    infoSubText: '',
                    textCardTitle: 'Customize Your Product',
                    textCardBody: 'You can choose to start a new imprint, or if you are a returning customer you can select “Use My Previous Artwork” - we keep your previous files on record. If you would like to make any changes to a previous imprint please comment any specifics in the “Special Instructions” box.',
                    additionalText: 'Alternatively, if you would like to send your art files after placing your order, select “Send Us Your Artwork After Ordering”. After placing your order, send an email to <a href="mailto:'+this.getEmail() +'">'+this.getEmail() +'</a> with your art files attached and Order Number in the subject line. Please provide artwork promptly so that our team can create a Digital Proof prior to production.'
                },

                {
                    id: 4,
                    navNextSubText: '',
                    navPrevSubText: 'Choose Product ' + this.getColorText() + ' and Quantity',
                    infoSubText: '',
                    textCardTitle: 'Customize Your Product',
                    textCardBody: 'Add your imprint here. You can choose to add Text, an Image or both! To start, choose where you would like to imprint your product and fill in the required info.',
                    additionalText: ''
                },
                {
                    id: 5,
                    navNextSubText: '',
                    navPrevSubText: 'Choose Product ' + this.getColorText() + ' and Quantity',
                    infoSubText: '',
                    textCardTitle: 'Customize Your Product',
                    textCardBody: 'Please send an email to <a href="mailto:'+this.getEmail() +'">' + this.getEmail() + '</a> with your art files attached and Order Number in the subject line. Please provide artwork promptly so that our team can create a Digital Proof prior to production. Note that your order will not proceed until we receive your artwork and create your proof.',
                    additionalText: '',
                    specialInstruction: 'Send Us Your Artwork After Ordering. ' + '\r\n\r\n' + 'Comment:'
                },
                {
                    id: 6,
                    navNextSubText: '',
                    navPrevSubText: 'Choose Product ' + this.getColorText() + ' and Quantity',
                    infoSubText: '',
                    textCardTitle: 'Customize Your Product',
                    textCardBody: 'If you are a returning customer, we have your previous art on file. Please specify which artwork you’re looking for, and if you would like to make any changes, please comment any specifics in the “Special Instructions” box. If you know your previous Order Number, please include it in the Special Instructions box below.',
                    additionalText: '',
                    specialInstruction: 'Use My Previous Artwork.' + '\r\n\r\n' + 'Comment:'
                }
            ],

            calendarStepInfo: [
                {
                    id: 1,
                    navNextSubText: 'Customize your Product',
                    navPrevSubText: '',
                    infoSubText: '',
                    textCardTitle: 'Choose Imprint Method',
                    textCardBody: 'Choose the imprint method that you would like your product to be customized with. The price grid below will update based on which imprint method is selected.',
                    additionalText: '',
                },
            ],

            maxStep: 3,
            store: store,
            responseProduct: {},
            mainProductID: null,
            minOrderQty: null,
            qtyIncrement: null,
            maxColorCount: 2,
            newImprint: null,
            validationMessages: {

            },
            validationResult: {
                hasError: false,
                imprintType: {
                    id: 1,
                    message: null
                }
            },
            addToCartSatatus: false,
            imprintTierData: {},
            cartState: false,
            stepForAddAssociatedFee: '', // 'first' or 'last'
            applicationType: 'default',
            cartObject: {},
            responsedCartItems: {},
            colorText: null,
            colorTextUppercase: null,
            currentGroupID: null,
            bundleProductCleared: false
        }
    },
    mounted() {
        this.isComda = window.location.href.includes('comda');
    },
    computed: {
        customColor() {
            return this.$getCustomColorClass(store.storeID);
        },
        customColorBefore() {
            return this.$getCustomColorBeforeClass(store.storeID);
        },
        customColorAfter() {
            return this.$getCustomColorAfterClass(store.storeID);
        },
        customFont() {
            return this.$getCustomFontClass(store.storeID);
        },
        customBackground() {
            return this.$getCustomBackgroundColorClass(store.storeID);
        },
        customBackgroundHover() {
            return this.$getCustomBackgroundColorHoverClass(store.storeID);
        },
        showTextCard(){
            let result = !this.store.isCustomBundlePage && this.applicationType !== 'calendar_single' && this.applicationType !== 'calendar';

            if (this.isComda && this.applicationType == 'calendar_single' && !this.store.isCustomBundlePage) {
                result = true;
            }

            return result;
        }
    },
    methods: {
        isImprintStepShow(step) {
            if(this.store.application_type == 'default' && step == 3) {
                return true;
            } else if(this.store.application_type == 'calendar' && step == 2) {
                return true;
            } else if(this.store.application_type == 'calendar_single' && step == 2) {
                return true;
            } else {
                return false;
            }
        },
        isAddToCartDisabled() {
            console.error("isAddToCartDisabled");
            console.log(this.store.isCustomBundlePage);
            console.log(this.bundleProductCleared);
            if(this.store.isCustomBundlePage && this.bundleProductCleared) {
                return true;
            } else {
                return this.store.disabledAddToCart;
            }
        },
        setSpecialInstruction(value){
            this.specialInstruction = value;
            this.store.selectedLastStep[this.store.imprintKey].special_instruction = value;
        },
        prev() {
            if(this.stepsDebugMode) {
                console.error(" before Prev Step");
                console.log(" step " + this.step);
                console.log( " maxStep " + this.maxStep );
            }
            if (this.step > 3) {
              this.step = 2;
            } else {
              this.step = this.step !== 1 ? this.step - 1 : this.step;
            }

            this.navigateCustomBundle();

            if(this.stepsDebugMode) {
                console.error(" aftere Prev Step");
                console.log(" step " + this.step);
                console.log( " maxStep " + this.maxStep );
            }
        },
        navigateCustomBundle() {
            if(this.store.isCustomBundlePage) {
                if(this.step === 1) {
                    this.calendarStepInfo[0] = this.stepInfo[0];
                    this.calendarStepInfo[0]['navNextSubText'] = "Customize your Product";
                }
                if(this.step === 2) {
                    this.calendarStepInfo[0] = this.stepInfo[1];
                    this.calendarStepInfo[0]['navPrevSubText'] = "Choose your Imprint Method";
                }
            }
        },
        next() {
            if(this.stepsDebugMode) {
                console.error(" before Next Step");
                console.log(" step " + this.step);
                console.log( " maxStep " + this.maxStep );
            }
            if (this.step == 2 && this.store.totalSizesQty[this.store.imprintKey] < this.store.inputProductData.minOrderQty || this.store.qtyError) {
                    this.step = 2;
                    console.log(" --- if ----");
            } else {
                console.log(" --- else ----");
                if (this.step == 2 && this.store.selectedLastStep[this.store.imprintKey].stepId) {
                    console.log(" --- else if ----");
                  this.step = this.store.selectedLastStep[this.store.imprintKey].stepId;
                }else{
                    console.log(" --- else else ----");
                    this.step = this.step !== this.maxStep ? this.step + 1 : this.step;
                }
            }

            this.store.lastMaxInitedStep = this.store.lastMaxInitedStep < this.step ? this.step : this.store.lastMaxInitedStep;
            this.navigateCustomBundle();

            if(this.stepsDebugMode) {
                console.error(" after Next Step");
                console.log(" step " + this.step);
                console.log( " maxStep " + this.maxStep );
            }

        },
        startNewImprint() {
            if(this.stepsDebugMode) {
                console.error(" before New Imprint");
                console.log(" step " + this.step);
                console.log( " maxStep " + this.maxStep );
            }
            this.initCartState();
            this.step = 4;
            this.store.selectedLastStep[this.store.imprintKey].stepId = 4;
            this.calendarStepInfo[0] = this.stepInfo[2];
            this.calendarStepInfo[0]['navPrevSubText'] = "Choose Product Color and Quantity";
            if(this.stepsDebugMode) {
                console.log(" step - 1 "  + (this.step-1) );
                console.warn(this.stepInfo);
                //console.log(this.stepInfo[this.step-1].textCardBody);
            }
        },
        sendUsYourArtworkAfterOrdering() {
            if(this.stepsDebugMode) {
                console.error(" sendUsYourArtworkAfterOrdering");
                console.log(" step " + this.step);
                console.log( " maxStep " + this.maxStep );
            }
            this.initCartState();
            this.step = 5;
            this.store.selectedLastStep[this.store.imprintKey].stepId = 5;
            this.calendarStepInfo[0] = this.stepInfo[3];
            this.calendarStepInfo[0]['navPrevSubText'] = "Choose Product Color and Quantity";
            this.calendarStepInfo[0]['specialInstruction'] = 'Send Us Your Artwork After Ordering. ' + '\r\n\r\n' + 'Comment:'
            this.store.disabledAddToCart = false;
            if(this.stepsDebugMode) {
                console.log(this.store);
               // console.log(" step - 1 "  + (this.step-1) );
                //console.log(this.stepInfo[this.step-1].textCardBody);
            }
        },
        useMyPreviousArtwork() {
            if(this.stepsDebugMode) {
                console.error(" before useMyPreviousArtwork ");
                console.log(" step " + this.step);
                console.log( " maxStep " + this.maxStep );
                console.log(this.calendarStepInfo);
                console.warn(this.store.isCustomBundlePage);
                console.warn(this.stepInfo);
            }
            this.initCartState();
            this.step = 6;
            this.store.selectedLastStep[this.store.imprintKey].stepId = 6;
            this.calendarStepInfo[0] = this.stepInfo[4];
            this.calendarStepInfo[0]['navPrevSubText'] = "Choose Product Color and Quantity";
            this.calendarStepInfo[0]['specialInstruction'] = 'Use My Previous Artwork.' + '\r\n\r\n' + 'Comment:'
            this.store.disabledAddToCart = false;
            if(this.stepsDebugMode) {
                console.error(" after useMyPreviousArtwork ");
                console.log(" step " + this.step);
                console.log( " maxStep " + this.maxStep );
                console.log( " stepInfo >>> " );
                console.log(this.stepInfo);
                console.log(" step - 1 "  + (this.step-1) );
            }
        },
        initCartState() {
            axios.get(window.Shopify.routes.root + 'cart.js')
                .then(
                    getCart => {
                        if(getCart.data.length) {
                            this.cartState = true;
                        } else {
                            this.cartState = false;
                        }
                    }
                );

        },
        backToParent() {
            this.step = this.maxStep;
            console.warn("back to parent");
            console.log(this.step);
            console.log(this.stepInfo[this.step-1]['navPrevSubText']);
            this.navigateCustomBundle();
            this.store.selectedLastStep[this.store.imprintKey].special_instruction = null;
        },
        setIncrementMinOrderQty() {
            console.error("setIncrementMinOrderQty");
            //console.error(e);
            this.minOrderQty = this.store.inputProductData.minOrderQty;
            this.qtyIncrement = this.store.inputProductData.qtyIncrement;
        },
        setActiveImprintType(id) {
            this.activeImprintTypeID = id;
        },
        validate() {
            console.error("@@@@@@@@@@@@@@@@@@@ this.store.imprintMessageColorLines[this.store.imprintKey] @@@@@@@@@@@@@@@");
            console.warn(this.store.colorSizeLines.length);
            console.warn(this.maxColorCount);
            console.warn(this.store.imprintMessageColorLines[this.store.imprintKey]);
            console.warn(this.store);
            console.warn(this.addToCartSatatus);
            console.warn(this.step);
            console.warn(this.step <= 4);

            let errors = {};
            if (this.step <= 4 ) {
                if(this.store.selectedLastStep[this.store.imprintKey].imprintTypeID === 1 || this.store.selectedLastStep[this.store.imprintKey].imprintTypeID === 3) {
                    this.store.imprintMessageColorLines[this.store.imprintKey].forEach(
                        (item, index) => {
                            // перетираэться перевыритиs
                            console.log("item.lineMessage.trim().length");
                            console.log(item.lineMessage.trim().length);
                            console.log(item);
                            console.log(!item.selectedColor && !item.lineMessage.trim().length && !errors.length);



                            if(item.type !== 'image') {
                                if(!item.lineMessage.trim().length) {
                                    errors[this.store.selectedLastStep[this.store.imprintKey].imprintTypeID + 'Line' + index] = "empty message";
                                }

                                if(!item.selectedColor) {
                                    errors[this.store.selectedLastStep[this.store.imprintKey].imprintTypeID + 'Line' + index] = "empty color";
                                }

                                if (Object.keys(errors).length) {
                                    this.store.disabledAddToCart = true;
                                    this.validationResult.hasError = true;
                                    this.validationResult.imprintType.id = this.store.selectedLastStep[this.store.imprintKey].imprintTypeID;
                                } else {
                                    this.validationResult.hasError = false;
                                    this.validationResult.imprintType.id = this.store.selectedLastStep[this.store.imprintKey].imprintTypeID;
                                    this.store.disabledAddToCart = true;
                                }
                                console.error("validate");
                                console.log(this.validationResult);
                            }

                        }
                    );
                }
                if(this.store.selectedLastStep[this.store.imprintKey].imprintTypeID >= 2) {

                    //!this.store.selectedLastStep[this.store.imprintKey].uploaded_image.trim().length
                    if(this.store.selectedLastStep[this.store.imprintKey].uploaded_image === null) {
                        errors[this.store.selectedLastStep[this.store.imprintKey].imprintTypeID + 'uploaded_image'] = 'not_uploaded';
                        this.validationResult.hasError = true;
                        this.validationResult.imprintType.id = this.store.selectedLastStep[this.store.imprintKey].imprintTypeID;
                    }
                }
            }

            console.warn(this.store.imprintMessageColorLines[this.store.imprintKey]);
            console.warn(">>>serrors");
            console.warn(errors);
            console.log(Object.keys(errors).length);
            return Object.keys(errors).length;
        },
        getLocationSKU(locationTitle) {
            let result = false;
            let selectedImprint = this.store.inputProductData.fullJson.configurable_array[this.store.selectedImprint.sku];
            selectedImprint.configurable_2_data.imprint_position._imprints.forEach( location => {
              if(!result) {
                result = location.title == locationTitle ? location.sku : false;
              }
            });
            return result;
        },
        prepareImprintDetails() {
            let result = {};
            result["Imprint location"] = this.store.selectedLastStep[this.store.imprintKey].imprintLocation;
            result["_Imprint Method SKU"] = this.store.sku.imprint.method.val;
            //result["_Imprint Location SKU"] = this.store.sku.imprint.location.val;
            result["_Imprint Location SKU"] = this.getLocationSKU(this.store.selectedLastStep[this.store.imprintKey].imprintLocation);
            result["imprint_lines"] = {};
            result['_colorUpcharge'] = this.store.inputProductData.colorUpcharge;
            result['_sizeUpcharge'] = this.store.inputProductData.sizeUpcharge;
            /** Fees **/
            if(this.store.imprintMessageColorLines[this.store.imprintKey][0].selectedColor != null ) {
                this.store.imprintMessageColorLines[this.store.imprintKey].forEach(
                    (colorItem, index) => {
                        let key = "Line";
                        if((this.store.selectedLastStep[this.store.imprintKey].imprintTypeID === 1 || this.store.selectedLastStep[this.store.imprintKey].imprintTypeID === 3) && colorItem.type === 'message') {
                            key = "Line " + (index + 1);
                            let imprintLineKey = "line" + (index + 1);

                            result[key + " text"] = colorItem.lineMessage;
                            result[key + " color"] = colorItem.selectedColor;

                            if(!colorItem.custommColor) {
                                result["_Imprint " + key + " Color SKU"] = colorItem.selectedColorObj.sku;
                            }

                            result["imprint_lines"][imprintLineKey] = {
                                type: colorItem.custommColor ? 'custom_color' : 'standard_color',
                                color: colorItem.selectedColor
                            }

                            result['_colorUpcharge'] = this.store.inputProductData.colorUpcharge;
                            result['_sizeUpcharge'] = this.store.inputProductData.sizeUpcharge;

                        }

                        if(this.store.selectedLastStep[this.store.imprintKey].imprintTypeID >= 2 && colorItem.type === 'image') {
                            key = "line_img";

                            result["imprint_lines"][key] = {
                                type: colorItem.custommColor ? 'custom_color' : 'standard_color',
                                color: colorItem.selectedColor
                            }

                            result["Add an Image Color"] = colorItem.selectedColor;

                            if(result["imprint_lines"][key]['type'] == 'standard_color') {
                                result["_Add an Image Color SKU"] = colorItem.selectedColorObj.sku;
                            }
                        }
                    }
                );
            }

            if(this.store.selectedLastStep[this.store.imprintKey].imprintTypeID >= 2 && this.store.selectedLastStep[this.store.imprintKey].uploaded_image) {
               result['Add an Image Filename'] = this.store.selectedLastStep[this.store.imprintKey].uploaded_image.file.name;
               result['_Add an Image Url'] = this.store.selectedLastStep[this.store.imprintKey].uploaded_image.href;
            }

            result['Special Instruction'] = this.store.selectedLastStep[this.store.imprintKey].special_instruction;
            // TODO take weight by color sku
            // result['_Product Weight'] = this.store.properties.product_weight.val;
            result['_groupID'] = this.currentGroupID;
            result['_qtyIncrement'] = this.store.inputProductData.qtyIncrement;

            if (this.step >= 5) {
              result['_colorUpcharge'] = this.store.inputProductData.colorUpcharge;
              result['_sizeUpcharge'] = this.store.inputProductData.sizeUpcharge;
            }

            console.error("prepareImprintDetails");
            console.warn(result);

            return result;
        },
        generateRandomString(length) {
            const characters =
                'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            let result = '';

            // Create an array of 32-bit unsigned integers
            const randomValues = new Uint32Array(length);

            // Generate random values
            window.crypto.getRandomValues(randomValues);
            randomValues.forEach((value) => {
                result += characters.charAt(value % charactersLength);
            });

            return result;
        },
        getGroupID() {
            let date = new Date;
            let timestamp = date.getTime();
            let randomString = this.generateRandomString(30);

            return timestamp + "_" + randomString;
        },
        lineItemsFeeFormatToCart(lineItemsFeeProperties){
            let feeFormated = {};
            console.error("START >>>>>>>>>>>lineItemsFeeFormatToCart>>>>>>>>>>>");
            console.log(lineItemsFeeProperties);
            console.warn(this.store.sku);

            if (typeof lineItemsFeeProperties === 'object') {
                for(const [key, value] of Object.entries(lineItemsFeeProperties)) {
                    switch(key) {
                        case 'setup_fee':
                            feeFormated['Setup Fee'] = value;
                            feeFormated['_Setup Fee SKU'] = this.store.sku.fee[key].val;
                        break;
                        case 'proof_fee':
                            feeFormated['Proof Fee'] = value;
                            feeFormated['_Proof Fee SKU'] = this.store.sku.fee[key].val;
                        break;
                        case 'image_fee':
                            feeFormated['Image Fee'] = value;
                            feeFormated['_Image Fee SKU'] = this.store.sku.fee[key].val;
                        break;
                        case 'running_fee':
                            feeFormated['Running Fee'] = value;
                            feeFormated['_Running Fee SKU'] = this.store.sku.fee[key].val;
                        break;
                        case 'custom_colour_fee':
                            feeFormated['Custom Colour Fee'] = value;
                            feeFormated['_Custom Colour Fee SKU'] = this.store.sku.fee[key].val;
                        break;
                        default:
                        break;
                    }
                }
            }

            console.error(">>>>>>>>>>>lineItemsFeeFormatToCart>>>>>>>>>>> end");
            console.log(feeFormated);
            feeFormated["_groupID"] = this.currentGroupID;
           return feeFormated;

        },
        isCustomerGuest() {
            let result = document.getElementById("customer_id").textContent;
            return !result;
        },
        addToCart() {
            let date = new Date();
                console.error(`$$$$$$$$$$$$$ Start js adding to cart script: ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()}` + date.getTime());

                if(this.step >= 5) {
                    let stepKey =  (this.store.application_type == 'calendar')? this.step - 2 : this.step - 1;
                    this.specialInstruction = this.stepInfo[stepKey].specialInstruction + ' ' + this.specialInstruction;
                    this.store.selectedLastStep[this.store.imprintKey].special_instruction = this.specialInstruction;
                    console.error('special');
                    console.warn(this.stepInfo[stepKey].specialInstruction);
                    console.warn(this.specialInstruction);
                    console.warn(this.store.selectedLastStep[this.store.imprintKey].special_instruction);
                }

                let resultv = this.validate();
                console.error("this.validate()");
                console.log(resultv);

                if (!this.validationResult.hasError) {

                    let imprintLinesData = this.prepareImprintDetails();
                    let prepareDataToCart = {
                            id: this.store.inputProuctIds.mainProductID,
                            imprint_lines: imprintLinesData.imprint_lines,
                            items: [

                            ]
                        };
                    /*
                       TODO twice calls the method this.prepareImprintDetails(); maybe current can be deleted
                       comment for test
                   */
                    //this.prepareImprintDetails();

                    /*** Prepare items with properties to cart if default mode
                     *  TODO improve condition if mode = this.store.application_type
                     *  Currently different logic will be added if add to cart 'calendar'
                     */
                    if(this.store.application_type == 'default') {
                        prepareDataToCart['colorProductID'] = this.store.inputProductData.associatedIds.simples.id_color;

                        console.error(">>>>>>>>> STEP 3 lines >>>>>>>>>>>>>>>>>");
                        console.warn(this.store.imprintMessageColorLines[this.store.imprintKey]);
                        console.log(this.store.selectedLastStep[this.store.imprintKey].imprintLocation);
                        console.warn(this.store.colorSizeLines);
                        console.error(">>>>>>>>> STEP 3 Lines end >>>>>>>>>>>>>>>>>");

                        this.store.colorSizeLines[store.imprintKey].forEach(
                            colorSizeLine => {
                                console.error("colorSizeLine");
                                console.log(colorSizeLine);
                                for (const prop in colorSizeLine.selectedSizes) {
                                    let prepareProperties = {};
                                    if(colorSizeLine.selectedSizes[prop]) {

                                        let formatedColorName = '';
                                        let outputColorName = colorSizeLine.slectedColor.title;
                                            if(outputColorName.includes("-")) {
                                                var words = outputColorName.split("-");
                                                for (let i = 0; i < words.length; i++) {
                                                        words[i] = words[i][0].toUpperCase() + words[i].slice(1);
                                                    }

                                                formatedColorName = words.join(" ");
                                            } else {
                                                formatedColorName = outputColorName[0].toUpperCase() + outputColorName.slice(1);
                                            }

                                        if(this.store.productType != 'grouped_plain') {

                                            prepareProperties = {
                                                'Color': colorSizeLine.slectedColor.title,
                                                'Size': prop,
                                                'Imprint Method': this.store.selectedImprint.tabName,
                                                '_Product name': `${this.store.inputProductData.fullJson.name + ' - ' +this.renameSize(prop) + ' (' +formatedColorName + ')'}`,
                                                '_img_src': colorSizeLine.slectedColor.img_src,
                                                '_price_details':this.store.prices,
                                                '_mainProductId': this.store.inputProuctIds.mainProductID,
                                                '_colorId': colorSizeLine.slectedColor.id
                                            }
                                        } else {
                                            prepareProperties = {
                                                'Color': colorSizeLine.slectedColor.title,
                                                'Imprint Method': this.store.selectedImprint.tabName,
                                                '_Product name': this.store.inputProductData.fullJson.name + ' - (' + formatedColorName +')',
                                                '_img_src': colorSizeLine.slectedColor.img_src,
                                                '_price_details':this.store.prices,
                                                '_mainProductId': this.store.inputProuctIds.mainProductID,
                                                '_colorId': colorSizeLine.slectedColor.id
                                            }
                                        }

                                        prepareProperties._productUrl = window.location.pathname;
                                        Object.assign(prepareProperties, imprintLinesData);
                                        delete prepareProperties.imprint_lines;
                                        console.error("????????ColorSku");
                                        console.log(colorSizeLine);

                                        let colorSkuArr = [];
                                        if(colorSizeLine.slectedColor.img_sku) {
                                            colorSkuArr = colorSizeLine.slectedColor.img_sku.split('_');
                                        }
                                        // prepare color sku by size
                                        let sizeCode = prop;
                                        if(this.store.hasFullSizeNames) {
                                            console.warn(">>>>>>>>>>>>>>>>>>>>>>>>>> colorSizeLine.slectedColor");
                                            console.log(colorSizeLine.slectedColor);
                                            sizeCode = this.store.fullSizeNameToShort[prop];
                                        }
                                        let prepareSkuBySize = this.store.productType === "grouped_plain" ?
                                            colorSizeLine.slectedColor.img_sku :
                                            this.store.inputProductData.fullJson.catalog_code + "_" + sizeCode + "_" + colorSkuArr[colorSkuArr.length - 1];

                                        console.error("let prepareSkuBySize = this.store.productType === grouped_plain");
                                        console.log(prepareSkuBySize);
                                        console.warn(this.store.selectedImprint.data.simple_array);
                                        console.error("end let prepareSkuBySize = this.store.productType === grouped_plain");

                                        if(this.store.selectedImprint.data.simple_array) {
                                            prepareProperties['_Product Weight'] = this.store.selectedImprint.data.simple_array[prepareSkuBySize].weight;
                                            prepareProperties['_Product Color'] = this.store.selectedImprint.data.simple_array[prepareSkuBySize].color;
                                            prepareProperties['_Product SKU'] = this.store.selectedImprint.data.simple_array[prepareSkuBySize].sku;
                                        }

                                    let prepareProduct = {
                                        id: colorSizeLine.slectedColor.id,
                                        quantity: colorSizeLine.selectedSizes[prop],
                                        properties: prepareProperties,
                                        // >>> metaData: optional, need delete for car
                                        metaData: {
                                            price: (this.store.prices.priceByQty).toFixed(2),
                                            productColorID: this.store.inputProductData.associatedIds.simples.id_color,
                                            imgID: colorSizeLine.slectedColor.img_id,
                                            imgGID: colorSizeLine.slectedColor['img_gid'] ? colorSizeLine.slectedColor['img_gid'] : null,
                                            color_sku: prepareSkuBySize,
                                            imprint_sku: this.store.selectedImprint.sku,
                                            mainProduct_id: this.store.inputProuctIds.mainProductID
                                        }
                                    }
                                    console.error("prepareProduct");
                                    console.log(prepareProduct);
                                    prepareDataToCart.items.push(prepareProduct);
                                }
                            }
                        }
                    );
                } else {
                    this.store.calendar.productList.forEach(
                        calendar => {
                            prepareDataToCart['id'] = calendar.id;
                            prepareDataToCart['colorProductID'] = calendar.id;
                            let prepareCalendar = {
                                id: calendar.id,
                                quantity: calendar.qty,
                                properties: {
                                    'Is Calendar': 'Yes',
                                    'Calendar SKU': calendar.calendar_sku,
                                    'Imprint Method': this.store.selectedImprint.tabName,
                                    '_variant_title': calendar.title,
                                    '_variant_title_img': calendar.image,
                                    '_Product name': calendar.title,
                                    '_img_src': calendar.image,
                                    '_Product SKU': calendar.calendar_sku,
                                    '_Product Weight':  this.store.selectedImprint.data.simple_array[calendar.calendar_sku].weight,
                                    '_mainProductId': calendar.id,
                                    '_price_details':this.store.prices,
                                    '_productUrl': window.location.pathname
                                },
                                // >>> metaData: optional, need delete for car
                                metaData: {
                                    price: (calendar.unitPrice).toFixed(2),
                                    productColorID: calendar.id,
                                    imgID: null,
                                    imprint_sku: this.store.selectedImprint.sku,
                                    mainProduct_id: calendar.id
                                }
                            }
                            Object.assign(prepareCalendar.properties, imprintLinesData);
                            delete prepareCalendar.properties.imprint_lines;
                            prepareDataToCart.items.push(prepareCalendar);
                        }
                    );
                }

                    console.error("Data for stor");
                    console.log(this.store);
                    console.log(this.store.colorSizeLines);
                    console.error(prepareDataToCart);

                    const apiData = {
                        'mode': this.store.application_type,
                        'associatedFeeID': window.PXUTheme.theme_settings.associated_fee_id,
                        'placeholderImageGID': window.PXUTheme.theme_settings.placeholder_image_gid,
                        'shop': 'mapleleafpromotions',
                        'shop_domain': 'mapleleafpromotions.myshopify.com',
                        'isCustomerGuest': this.store.isCustomerGuest,
                        'data': prepareDataToCart
                    }

                    let laravelEnvShop = process.env.APP_ENV;
                    console.error('>>>>>>>>>>>>>>>>>>>>>>>>   laravelEnvShop   <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<');
                    console.error(laravelEnvShop);

                    let apiBaseUrl = "https://dev.api-customapp.comda.com/";

                    if(window.PXUTheme.theme_settings.api_beckend_url) {
                        apiBaseUrl = window.PXUTheme.theme_settings.api_beckend_url;
                    } else {
                        console.error("Please set theme setting: api_beckend_url");
                    }

                    if(window.PXUTheme.theme_settings.api_shop_domain) {
                        let domainStr = window.PXUTheme.theme_settings.api_shop_domain;
                        apiData.shop_domain = window.PXUTheme.theme_settings.api_shop_domain;
                        apiData.shop = domainStr.replace('.myshopify.com', '');
                        console.error("GET Shop domain from theme Settings");
                        console.warn(apiData);
                    } else {
                        console.error("Please set theme setting: api_shop_domain");
                    }
                    console.error("API base Url !!!!!!!! >>>>>>>>>> !!!!!!!!!!!!! >>>>>>>>>> !!!!!!!!!!!!!!");
                    console.log(apiBaseUrl);
                    console.warn(window.PXUTheme.theme_settings.api_beckend_url);
                    let endpoint = "api/get/testfrontapi";
                    endpoint ='api/shopify/addtocart';
                    //let endpoint = "api/get/testapi"
                    this.addToCartSatatus = true;

                    // let isCartNotEmpty = false;
                    console.error("######## STORE state after click on button ADD to cart >>>>>>>>>>>>>>> ");
                    console.warn(this.store);

                    this.asincAddToCart(apiBaseUrl, endpoint, apiData);
                }

        },

        asincAddToCart(apiBaseUrl, endpoint, apiData) {
            let commonFirstSecond = [];
            let first = [];
            let last = [];

            axios.post(apiBaseUrl + endpoint, apiData)
                .then(backendResponse => {
                    console.error("backendResponse222222");
                    console.error(backendResponse);
                    console.warn(typeof backendResponse.data);
                    console.warn(backendResponse.data);
                    let lineItems = {};

                    if (typeof backendResponse.data == 'string') {
                        lineItems = this.getJsonResponseFromString(backendResponse.data);
                    } else {
                        lineItems = backendResponse.data.responesVariantsList;
                    }

                    let productFeeProperties = this.lineItemsFeeFormatToCart(lineItems.items.product_fee.properties);
                    lineItems.items.product_fee.properties = productFeeProperties;
                    let feeCartLine = [lineItems.items.product_fee];
                    let sortedItems = [];

                    for (const [key, value] of Object.entries(lineItems.items)) {
                        console.warn(typeof key);
                        if (key !== 'product_fee') {
                          sortedItems.push(value);
                          console.log(`${key}: ${value}`);
                        }
                    }

                    if (this.cartState) {
                        first = sortedItems;
                        last = feeCartLine;
                        this.stepForAddAssociatedFee = 'last';
                    } else {
                        first = feeCartLine;
                        this.stepForAddAssociatedFee = 'first';
                        last = sortedItems;
                    }

                    commonFirstSecond.push(first);
                    commonFirstSecond.push(last);
                    console.error("@@@@@@@ Prepeared to cart <<<<<<<<<");
                    console.log(Object.assign({}, sortedItems));

                    this.setMinQtyToStorage();
                    this.asincAddToCartFirst(first, last);
                })
                .catch(
                    error => {
                        console.error("this.errors = error.response.data");
                        console.log(error);
                    }
                )
                return commonFirstSecond;
        },

        asincAddToCartFirst(first, last) {
             axios.post(window.Shopify.routes.root + 'cart/add.js', {items: first})
            .then(
                response => {
                    console.warn("Cart Response");
                    console.warn(response.data);
                    console.error("this.stepForAddAssociatedFee");
                    console.log(this.stepForAddAssociatedFee);

                  response.data.items.forEach(item => {
                    if (!Object.hasOwn(item.variant_id, this.responsedCartItems)) {
                      this.responsedCartItems[item.variant_id] = item
                    }
                  });
                    this.asincAddToCartSecond(last);
                }
            )
            .catch(
                error => {
                    console.error("First this.errors = error.response.data");
                    console.log(error);
                    return null;
                }
            )
        },

        asincAddToCartSecond(last) {
             axios.post(window.Shopify.routes.root + 'cart/add.js', {items: last})
            .then(
                response => {
                    if(response) {
                        console.error("Last Response");
                        console.log(response);
                        console.error("this.stepForAddAssociatedFee");
                        console.log(this.stepForAddAssociatedFee);

                      response.data.items.forEach(item => {
                        if (!Object.hasOwn(item.variant_id, this.responsedCartItems)) {
                          console.log(item);
                          console.log('item +');
                          this.responsedCartItems[item.variant_id] = item
                        }
                      });

                        this.addToCartSatatus = false;
                        this.store.selectedLastStep[this.store.imprintKey].special_instruction = null;
                        let date = new Date();
                        console.error(`$$$$$$$$$$$$$ End js adding to cart script: ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()}` + date.getTime());
                        console.log(" >>>> getFromCart ");
                        this.getFromCart();
                        localStorage.removeItem("stringProductList");
                        localStorage.removeItem("fullStorageProductList");
                        if(window.jQuery("#add-to-cart-complited")) {
                            window.jQuery("#add-to-cart-complited").trigger("click");
                        }
                        let el = document.querySelectorAll('body .cart-container')[1];
                        el.className += " active_link";
                        window.scrollTo(0,10);

                        if(store.isCustomBundlePage) {
                            this.store.disabledAddToCart = true;
                            this.bundleProductCleared = true;
                        } else {
                            this.store.disabledAddToCart = false;
                        }

                        this.currentGroupID = this.getGroupID();
                    }
                }
            ).catch(
                error => {
                    console.error("Last this.errors = error.response.data");
                    console.log(error);
                }
            );
        },

        getJsonResponseFromString(string) {
            let cutKey = "responesVariantsList";
            let indexOfCutKey = string.indexOf(cutKey);
            let cutedData = string.slice(indexOfCutKey, string.length);
            let jsonTypeResponse = '{"' + cutedData;

            let formatedStr = jsonTypeResponse.replace(/\\"\s*W/g, '\\" W')
                .replace(/\\"\s*H/g, '\\" H');
            let jsonResponse = JSON.parse(formatedStr);

            if (cutKey in jsonResponse) {
                return jsonResponse[cutKey];
            } else {
              console.error("Bad response>>: " + jsonResponse);
            }
        },

        setMinQtyToStorage(){
            let minQty = {};
            minQty.minQty = this.store.inputProductData.minOrderQty;

            if (this.store.application_type == 'calendar' || this.store.application_type == 'calendar_single') {
                minQty.minQty = this.isComda ? 100 : 150;//150 in bundle applications
            }

            minQty.errrorMessage = false;
            let minQtyStorage = JSON.parse(localStorage.getItem('minQty'));

            if(!minQtyStorage){
                minQtyStorage = {};
            }

            minQtyStorage[this.currentGroupID] = minQty;
            localStorage.setItem('minQty', JSON.stringify(minQtyStorage));
        },
        getFromCart() {
            axios.get(window.Shopify.routes.root + 'cart.js')
            .then(
                response => {
                    console.warn("getFromCart response.data");
                    if(response.data) {
                        this.cartObject = response.data;
                        this.updateCartItemsInCartObject();

                    }
                    console.warn(response.data);
                }
            );
        },
        updateCartItemsInCartObject() {
            if (this.cartObject.items.length && this.responsedCartItems) {
                console.error("this.cartObject.items.length && this.responsedCartItems.length");
                    this.cartObject.items.map( (item, index) => {
                        console.error("item updateCartItemsInCartObject");
                        console.error(item);
                        if (!item.image && this.responsedCartItems) {
                            this.cartObject.items[index] = this.responsedCartItems[item.variant_id];
                        }
                    }
                );

                console.error(" Result updating cart object ");
                console.warn(this.cartObject);
                window.miniCart.refreshMiniCart(this.cartObject,true);
                //sessionStorage.setItem('cartItems', JSON.stringify(this.cartObject));
                localStorage.setItem('cartItems', JSON.stringify(this.cartObject));
            }
        },
        checkIsSpecial() {
            return Object.keys(this.store.specialPrice.byImprintMethods).includes(this.store.selectedImprint.sku);
        },
        addNewColorSizeLine() {
            let emptyColorSizeObj = {
                slectedColor: {
                    id: null,
                    title: '',
                    img_src: ''
                },
                selectedSizes: {}
            };

            if(this.store.productType === 'grouped_plain'){
              emptyColorSizeObj.selectedSizes.qty =  store.prices.tier[1].QtyMin ? store.prices.tier[1].QtyMin : 0;
            }

            this.store.colorSizeLines[store.imprintKey].push(emptyColorSizeObj);


        },
        getProductByHandle(handle) {
            axios.get(window.Shopify.routes.root + 'products/' + handle + '.js')
                .then(response => {
                        console.error('>>>>>>>>>>>> Product by handle >>>>>>>>>>>');
                        console.log(response.data);
                        console.log(response.data.type);
                        this.setProductType(response.data.type);
                    }
                );
        },
        setProductType(type) {
            this.store.productType = type;
        },
        initMainProductID() {
            let response = null;

            if(window.location.pathname != "/collections/calendar-bundle-custom") {
                response = document.getElementById("current_main_product_id").textContent;
                this.mainProductID = parseInt(response);
                console.error("----- Calendar Bundle page ------");
            // TODO remove if not need, not found console logs for this case "----- ???? Calendar Bundle page else if------"
            } else if(this.applicationType == "calendar_single") {
                console.error("----- ???? Calendar Bundle page else if------");
                delete this.stepInfo[1];
                this.stepInfo[2].id = 2;
                response = window.jQuery(".main_product_id")[0].textContent;
                this.mainProductID = parseInt(response);
                this.full_product = JSON.parse(window.jQuery(".full_product_info_json-" + this.mainProductID)[0].textContent);
            } else {
                console.error("----- Calendar Bundle page only else ------");
                this.store.application_type = 'calendar';
                delete this.stepInfo[1];
                this.stepInfo[2].id = 2;
                response = window.jQuery(".main_product_id")[0].textContent;
                this.mainProductID = parseInt(response);
                this.full_product = JSON.parse(window.jQuery(".full_product_info_json-" + this.mainProductID)[0].textContent);
            }
            console.error("mainProductID ^^^^^^^^^^^^^^^^^^^");
            console.warn(this.store);
            console.log(parseInt(response));

            this.full_product_json = JSON.parse(document.getElementById("full_product_info_json").textContent);
        },
        async getMainProductHandleById(id) {
            let response = null;

            // Get handle
            response = await axios.get(`/search/suggest.json?q=id:${id}&resources[type]=product&limit=1`);
            this.responseProduct = response !== null ? response.data : null;

            // Get product by handle
            this.getProductByHandle(this.responseProduct.resources.results.products[0].handle);

        },
        afterLoadedColors(value) {
            this.maxColorCount = value;
            console.error("event afterLoadedColors");
        },

        afterSetImprintTier(value) {
            console.warn(">>>>>>>>>>>>. !!!!!!! afterSetImprintTier");
            this.store.perItemFee.proof_fee = value.proof_fee
            this.imprintTierData = value;
            console.log(this.store.perItemFee.proof_fee);
        },

        showAddToCartButton(uploaddedImage) {
        let activeTextTab = (this.store.selectedLastStep[this.store.imprintKey].imprintTypeID == 1) ? true : false;
        let activeImageTab = (this.store.selectedLastStep[this.store.imprintKey].imprintTypeID == 2) ? true : false;
        let activeTextAndImageTab = (this.store.selectedLastStep[this.store.imprintKey].imprintTypeID == 3) ? true : false;
        let disabledAddToCart = (activeTextTab || activeImageTab || activeTextAndImageTab) ? true : false;
        let mesageLineFilled = null;

        this.store.imprintMessageColorLines[this.store.imprintKey].forEach((item) => {
          if (activeTextTab && item.type == "message" ) {
            disabledAddToCart = true;
            if (item.selectedColor != null && item.lineMessage != "" && mesageLineFilled !== false) {
              disabledAddToCart = false;
            } else {
              disabledAddToCart = true;
              mesageLineFilled = false;
            }
          }

          if (activeImageTab && item.type == "image") {
            disabledAddToCart = true;
            if (item.selectedColor != null && (this.store.selectedLastStep[this.store.imprintKey].uploaded_image != null || uploaddedImage) ) {
              disabledAddToCart = false;
            }
          }

          if(activeTextAndImageTab) {
            disabledAddToCart = true;
            if (item.type == "message"  && mesageLineFilled !== false) {
              if (item.selectedColor != null && item.lineMessage != "") {
                disabledAddToCart = false;
              } else {
                disabledAddToCart = true;
                mesageLineFilled = false;
              }
            }
            if (item.type == "image" && (uploaddedImage || this.store.selectedLastStep[this.store.imprintKey].uploaded_image != null) && mesageLineFilled != false) {
              disabledAddToCart = true;
              if (item.selectedColor != null) {
                disabledAddToCart = false;
              }
            }
          }
        });

        this.store.disabledAddToCart = disabledAddToCart;
      },

        afterNewImprintChanged(value) {
            this.validationResult.hasError = false;
            this.validationResult.imprintType.id = this.store.selectedLastStep[this.store.imprintKey].imprintTypeID;
            this.addToCartSatatus = false;
            this.showAddToCartButton(value.imageUploaded);


            let uniqueColors = [];
            let uniqueCustomColors = [];
            this.store.imprintMessageColorLines[this.store.imprintKey].forEach( item => {
                if(item.selectedColor !== null && item.custommColor !== true && !uniqueColors.includes(item.selectedColor)) {
                    uniqueColors.push(item.selectedColor);
                    this.store.selectedLastStep[this.store.imprintKey].uniqueColors = uniqueColors;
                    this.store.selectedLastStep[this.store.imprintKey].uniqueColorsCount = uniqueColors.length;
                }

            if(item.selectedColor !== null && item.custommColor === true && !uniqueCustomColors.includes(item.selectedColor)) {
                uniqueCustomColors.push(item.selectedColor);
            }
        });

        console.error("uniqueColors");
        console.log(uniqueColors);

        if(uniqueColors.length && this.store.perItemFee.setupFee) {
            this.store.setupFee = (uniqueColors.length - 1) * this.store.perItemFee.setupFee;
        }

        if(uniqueColors.length && this.store.perItemFee.running_fee) {
            this.store.prices.running_fee = (uniqueColors.length - 1) * this.store.perItemFee.running_fee;
        }

        console.error("uniqueCustomColors >>>>>>>>>");
        console.log(uniqueCustomColors);
        console.error(uniqueCustomColors.length);

        this.store.customColourFee[this.store.imprintKey] = uniqueCustomColors.length * this.store.perItemFee.customColourFee;

        if(!value.imageUploaded){
          // TODO this.newImprint check why we use that, maybe for event update data
          this.newImprint = value; // for render summary
          console.error("event new imprint fired");
          //console.log(this.store.imprintMessageColorLines[this.store.imprintKey]);

          console.log(this.store.customColourFee);
          console.error(uniqueCustomColors.length * this.store.perItemFee.customColourFee);
          console.log(this.store.setupFee);
        }
    },
        getColorText(loverCase = false){
          if(!this.colorText && !this.colorTextUppercase){
            let result = (window.Shopify.country == 'US') ? 'Color' : 'Colour';
            this.colorText = result;
            this.colorTextUppercase = result.toLowerCase();
          }

          return (!loverCase) ?  this.colorText : this.colorTextUppercase;
        },
        initProductsfromCalendarStorage() {
            let prWrPrefix = '.product-main-wrap-';
            this.stepInfo.splice(1,1);
            this.maxStep = 2;
            console.error("++++++++++++ Calendar STORE +++++++++++++");
            console.log(this.stepInfo);
            if (localStorage.fullStorageProductList && localStorage.fullStorageProductList.length) {
                this.store.calendar.productList = JSON.parse(localStorage.fullStorageProductList);

                this.store.calendar.productList.forEach(
                    calProduct => {
                        console.error("999999999999999999999 Addd Qty El &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
                        console.log(prWrPrefix+calProduct.id + " > .product-info__caption");
                        console.warn(window.jQuery(prWrPrefix+calProduct.id + " > .product-info__caption"));
                        if(window.jQuery(prWrPrefix+calProduct.id + " > .product-info__caption")) {
                            let qtyTag = `<div class='customize-bundle customize-bundle-page__qty'>
                                <span class='customize-bundle__qty-key'>Quantity: </span>
                                <span class='customize-bundle__qty-value'>${calProduct.qty}</span></div>`
                                window.jQuery(window.jQuery(prWrPrefix+calProduct.id + " > .product-info__caption")[0]).append(qtyTag);
                        }

                    }
                );
            }
        },
        renameSize(size){
           let sizeNames = {
               'S' : "Small",
               'M' : "Medium",
               'L' : "Large",
           }
           let lastChar = size.slice(-1);

           if(lastChar in sizeNames){
               if(size.length>1){
                   size =size.slice(0, -1) + ' ' + sizeNames[lastChar];
               }else{
                   size = sizeNames[lastChar];
               }
           }

          return size;
        },
        getEmail(){
            return window.location.href.includes('comda') ? 'artwork@comda.com' : 'mlcs@mapleleafpromotions.com';
        }
    },
    created() {
        this.currentGroupID = this.getGroupID();
        this.store.isCustomerGuest = this.isCustomerGuest();
        if(window.jQuery("#calendar-qty-changed")) {
            window.jQuery("body").on("click","#calendar-qty-changed",
                (event)=> {
                    console.log(event);
                    console.warn("Step navigation created hook ");
                    if(window.jQuery("#calendar-imprint-common-qty")) {
                        console.error(window.jQuery("#calendar-imprint-common-qty").val());

                        //this.initProductsfromCalendarStorage();
                    }
                }
            );
        }

        if(window.PXUTheme.theme_settings.project_store_name && window.Shopify.country) {
            this.store.storeID = window.PXUTheme.theme_settings.project_store_name + "_" + window.Shopify.country.toLowerCase();
        }

        let singleCalendarBundleTag = 'no';
        if(document.getElementById("it-is-bundle-product")) {
            singleCalendarBundleTag = document.getElementById("it-is-bundle-product").textContent;
            if(singleCalendarBundleTag == 'yes') {
                this.store.application_type = 'calendar_single';
                this.applicationType = 'calendar_single';
            }
        }
        let customBundlePage = 'no';
        if(document.getElementById("it-is-bundle-custom-page")) {
            customBundlePage = document.getElementById("it-is-bundle-custom-page").textContent;
            if(customBundlePage == 'yes') {
                this.store.isCustomBundlePage = true;
                console.error("++++++++++++ customBundlePage +++++++++++++");
            }
        }

        this.initMainProductID();
        console.error("++++++++++++ Application Type +++++++++++++");
        console.log(this.store.application_type);
        console.log(this.applicationType);

        //localStorage.removeItem("storageProductList");
        if(this.mainProductID !== null) {
            this.getMainProductHandleById(this.mainProductID);
            this.store.inputProuctIds.mainProductID = this.mainProductID;
        }
        if (this.store.application_type == 'calendar') {
            this.initProductsfromCalendarStorage();
        }
        if (this.store.application_type == 'calendar_single') {
            console.error("++++++++++++ Application Type +++++++++++++");
            console.log(this.store.application_type);
            this.stepInfo.splice(1,1);
            this.maxStep = 2;
        }

        console.warn("++++++++++++ STORE +++++++++++++");
        console.log(this.store);
        if(localStorage.storageProductList) {
            console.log(localStorage.storageProductList);
            console.error(JSON.parse(localStorage.storageProductList));
            console.warn("++++++++++++ fullStorageProductList +++++++++++++");
            console.error(JSON.parse(localStorage.fullStorageProductList));
        }

        if(!localStorage.getItem('cartItems')){
            localStorage.removeItem('minQty');
        }
    }
}


</script>

<style>
/* Fonts Start */
/*
 * The Typekit service used to deliver this font or fonts for use on websites
 * is provided by Adobe and is subject to these Terms of Use
 * http://www.adobe.com/products/eulas/tou_typekit. For font license
 * information, see the list below.
 *
 * museo:
 *   - http://typekit.com/eulas/00000000000000007735993f
 *   - http://typekit.com/eulas/000000000000000000011b23
 *   - http://typekit.com/eulas/000000000000000077359947
 *   - http://typekit.com/eulas/000000000000000000011b24
 *   - http://typekit.com/eulas/000000000000000077359958
 *   - http://typekit.com/eulas/00000000000000007735997d
 *   - http://typekit.com/eulas/000000000000000077359969
 *   - http://typekit.com/eulas/000000000000000077359952
 *   - http://typekit.com/eulas/000000000000000077359949
 *   - http://typekit.com/eulas/000000000000000077359967
 * museo-sans:
 *   - http://typekit.com/eulas/00000000000000000000e800
 *   - http://typekit.com/eulas/00000000000000000000e801
 *   - http://typekit.com/eulas/00000000000000000000e7fe
 *   - http://typekit.com/eulas/00000000000000000000e802
 *   - http://typekit.com/eulas/00000000000000000000e803
 *   - http://typekit.com/eulas/00000000000000000000e804
 *   - http://typekit.com/eulas/00000000000000000000e805
 *   - http://typekit.com/eulas/00000000000000000000e806
 *   - http://typekit.com/eulas/00000000000000000000e807
 *   - http://typekit.com/eulas/00000000000000000000e808
 * museo-sans-condensed:
 *   - http://typekit.com/eulas/000000000000000000012ca6
 *   - http://typekit.com/eulas/000000000000000000012ca7
 *   - http://typekit.com/eulas/000000000000000000012caa
 *   - http://typekit.com/eulas/000000000000000000012cab
 *   - http://typekit.com/eulas/000000000000000077359968
 *   - http://typekit.com/eulas/00000000000000007735994d
 *   - http://typekit.com/eulas/000000000000000000012ca8
 *   - http://typekit.com/eulas/000000000000000000012ca9
 *   - http://typekit.com/eulas/00000000000000007735995c
 *   - http://typekit.com/eulas/00000000000000007735995d
 *
 * © 2009-2023 Adobe Systems Incorporated. All Rights Reserved.
 */
/*{"last_published":"2023-02-01 21:24:01 UTC"}*/

@import url("https://p.typekit.net/p.css?s=1&k=fzx7sjl&ht=tk&f=1980.1981.1982.1983.1984.8541.8542.8543.8544.8545.2003.2004.2005.2006.2007.2008.2009.2010.2011.2012.17398.17399.17400.17401.17402.17403.17404.17405.17406.17407&a=86896830&app=typekit&e=css");

@font-face {
font-family:"museo";
src:url("https://use.typekit.net/af/38974e/00000000000000007735993f/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n1&v=3") format("woff2"),url("https://use.typekit.net/af/38974e/00000000000000007735993f/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n1&v=3") format("woff"),url("https://use.typekit.net/af/38974e/00000000000000007735993f/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n1&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:100;font-stretch:normal;
}

@font-face {
font-family:"museo";
src:url("https://use.typekit.net/af/f7c91f/000000000000000000011b23/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("woff2"),url("https://use.typekit.net/af/f7c91f/000000000000000000011b23/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("woff"),url("https://use.typekit.net/af/f7c91f/000000000000000000011b23/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:300;font-stretch:normal;
}

@font-face {
font-family:"museo";
src:url("https://use.typekit.net/af/d23205/000000000000000077359947/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("woff2"),url("https://use.typekit.net/af/d23205/000000000000000077359947/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("woff"),url("https://use.typekit.net/af/d23205/000000000000000077359947/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:500;font-stretch:normal;
}

@font-face {
font-family:"museo";
src:url("https://use.typekit.net/af/8a79e7/000000000000000000011b24/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff2"),url("https://use.typekit.net/af/8a79e7/000000000000000000011b24/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff"),url("https://use.typekit.net/af/8a79e7/000000000000000000011b24/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:700;font-stretch:normal;
}

@font-face {
font-family:"museo";
src:url("https://use.typekit.net/af/12040f/000000000000000077359958/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("woff2"),url("https://use.typekit.net/af/12040f/000000000000000077359958/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("woff"),url("https://use.typekit.net/af/12040f/000000000000000077359958/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:900;font-stretch:normal;
}

@font-face {
font-family:"museo";
src:url("https://use.typekit.net/af/088ff9/00000000000000007735997d/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i1&v=3") format("woff2"),url("https://use.typekit.net/af/088ff9/00000000000000007735997d/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i1&v=3") format("woff"),url("https://use.typekit.net/af/088ff9/00000000000000007735997d/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i1&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:100;font-stretch:normal;
}

@font-face {
font-family:"museo";
src:url("https://use.typekit.net/af/64e458/000000000000000077359969/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3") format("woff2"),url("https://use.typekit.net/af/64e458/000000000000000077359969/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3") format("woff"),url("https://use.typekit.net/af/64e458/000000000000000077359969/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:300;font-stretch:normal;
}

@font-face {
font-family:"museo";
src:url("https://use.typekit.net/af/2dc4e0/000000000000000077359952/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("woff2"),url("https://use.typekit.net/af/2dc4e0/000000000000000077359952/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("woff"),url("https://use.typekit.net/af/2dc4e0/000000000000000077359952/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:500;font-stretch:normal;
}

@font-face {
font-family:"museo";
src:url("https://use.typekit.net/af/3e30bd/000000000000000077359949/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff2"),url("https://use.typekit.net/af/3e30bd/000000000000000077359949/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff"),url("https://use.typekit.net/af/3e30bd/000000000000000077359949/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:700;font-stretch:normal;
}

@font-face {
font-family:"museo";
src:url("https://use.typekit.net/af/eaeb90/000000000000000077359967/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("woff2"),url("https://use.typekit.net/af/eaeb90/000000000000000077359967/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("woff"),url("https://use.typekit.net/af/eaeb90/000000000000000077359967/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:900;font-stretch:normal;
}

@font-face {
font-family:"museo-sans";
src:url("https://use.typekit.net/af/635674/00000000000000000000e800/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n1&v=3") format("woff2"),url("https://use.typekit.net/af/635674/00000000000000000000e800/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n1&v=3") format("woff"),url("https://use.typekit.net/af/635674/00000000000000000000e800/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n1&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:100;font-stretch:normal;
}

@font-face {
font-family:"museo-sans";
src:url("https://use.typekit.net/af/47003b/00000000000000000000e801/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i1&v=3") format("woff2"),url("https://use.typekit.net/af/47003b/00000000000000000000e801/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i1&v=3") format("woff"),url("https://use.typekit.net/af/47003b/00000000000000000000e801/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i1&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:100;font-stretch:normal;
}

@font-face {
font-family:"museo-sans";
src:url("https://use.typekit.net/af/620bf8/00000000000000000000e7fe/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("woff2"),url("https://use.typekit.net/af/620bf8/00000000000000000000e7fe/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("woff"),url("https://use.typekit.net/af/620bf8/00000000000000000000e7fe/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:300;font-stretch:normal;
}

@font-face {
font-family:"museo-sans";
src:url("https://use.typekit.net/af/5cca6d/00000000000000000000e802/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3") format("woff2"),url("https://use.typekit.net/af/5cca6d/00000000000000000000e802/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3") format("woff"),url("https://use.typekit.net/af/5cca6d/00000000000000000000e802/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:300;font-stretch:normal;
}

@font-face {
font-family:"museo-sans";
src:url("https://use.typekit.net/af/a28b50/00000000000000000000e803/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("woff2"),url("https://use.typekit.net/af/a28b50/00000000000000000000e803/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("woff"),url("https://use.typekit.net/af/a28b50/00000000000000000000e803/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:500;font-stretch:normal;
}

@font-face {
font-family:"museo-sans";
src:url("https://use.typekit.net/af/c2d3de/00000000000000000000e804/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("woff2"),url("https://use.typekit.net/af/c2d3de/00000000000000000000e804/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("woff"),url("https://use.typekit.net/af/c2d3de/00000000000000000000e804/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:500;font-stretch:normal;
}

@font-face {
font-family:"museo-sans";
src:url("https://use.typekit.net/af/e3ca36/00000000000000000000e805/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff2"),url("https://use.typekit.net/af/e3ca36/00000000000000000000e805/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff"),url("https://use.typekit.net/af/e3ca36/00000000000000000000e805/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:700;font-stretch:normal;
}

@font-face {
font-family:"museo-sans";
src:url("https://use.typekit.net/af/2841b6/00000000000000000000e806/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff2"),url("https://use.typekit.net/af/2841b6/00000000000000000000e806/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff"),url("https://use.typekit.net/af/2841b6/00000000000000000000e806/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:700;font-stretch:normal;
}

@font-face {
font-family:"museo-sans";
src:url("https://use.typekit.net/af/9cf49e/00000000000000000000e807/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("woff2"),url("https://use.typekit.net/af/9cf49e/00000000000000000000e807/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("woff"),url("https://use.typekit.net/af/9cf49e/00000000000000000000e807/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:900;font-stretch:normal;
}

@font-face {
font-family:"museo-sans";
src:url("https://use.typekit.net/af/27c143/00000000000000000000e808/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("woff2"),url("https://use.typekit.net/af/27c143/00000000000000000000e808/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("woff"),url("https://use.typekit.net/af/27c143/00000000000000000000e808/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:900;font-stretch:normal;
}

@font-face {
font-family:"museo-sans-condensed";
src:url("https://use.typekit.net/af/da6ab2/000000000000000000012ca6/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("woff2"),url("https://use.typekit.net/af/da6ab2/000000000000000000012ca6/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("woff"),url("https://use.typekit.net/af/da6ab2/000000000000000000012ca6/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:300;font-stretch:normal;
}

@font-face {
font-family:"museo-sans-condensed";
src:url("https://use.typekit.net/af/f58f65/000000000000000000012ca7/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3") format("woff2"),url("https://use.typekit.net/af/f58f65/000000000000000000012ca7/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3") format("woff"),url("https://use.typekit.net/af/f58f65/000000000000000000012ca7/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:300;font-stretch:normal;
}

@font-face {
font-family:"museo-sans-condensed";
src:url("https://use.typekit.net/af/592eea/000000000000000000012caa/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff2"),url("https://use.typekit.net/af/592eea/000000000000000000012caa/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff"),url("https://use.typekit.net/af/592eea/000000000000000000012caa/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:700;font-stretch:normal;
}

@font-face {
font-family:"museo-sans-condensed";
src:url("https://use.typekit.net/af/9c0805/000000000000000000012cab/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff2"),url("https://use.typekit.net/af/9c0805/000000000000000000012cab/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff"),url("https://use.typekit.net/af/9c0805/000000000000000000012cab/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:700;font-stretch:normal;
}

@font-face {
font-family:"museo-sans-condensed";
src:url("https://use.typekit.net/af/ac10d8/000000000000000077359968/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n1&v=3") format("woff2"),url("https://use.typekit.net/af/ac10d8/000000000000000077359968/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n1&v=3") format("woff"),url("https://use.typekit.net/af/ac10d8/000000000000000077359968/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n1&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:100;font-stretch:normal;
}

@font-face {
font-family:"museo-sans-condensed";
src:url("https://use.typekit.net/af/da67ed/00000000000000007735994d/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i1&v=3") format("woff2"),url("https://use.typekit.net/af/da67ed/00000000000000007735994d/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i1&v=3") format("woff"),url("https://use.typekit.net/af/da67ed/00000000000000007735994d/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i1&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:100;font-stretch:normal;
}

@font-face {
font-family:"museo-sans-condensed";
src:url("https://use.typekit.net/af/514cc2/000000000000000000012ca8/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("woff2"),url("https://use.typekit.net/af/514cc2/000000000000000000012ca8/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("woff"),url("https://use.typekit.net/af/514cc2/000000000000000000012ca8/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:500;font-stretch:normal;
}

@font-face {
font-family:"museo-sans-condensed";
src:url("https://use.typekit.net/af/a84d3d/000000000000000000012ca9/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("woff2"),url("https://use.typekit.net/af/a84d3d/000000000000000000012ca9/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("woff"),url("https://use.typekit.net/af/a84d3d/000000000000000000012ca9/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:500;font-stretch:normal;
}

@font-face {
font-family:"museo-sans-condensed";
src:url("https://use.typekit.net/af/87c5cb/00000000000000007735995c/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("woff2"),url("https://use.typekit.net/af/87c5cb/00000000000000007735995c/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("woff"),url("https://use.typekit.net/af/87c5cb/00000000000000007735995c/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:900;font-stretch:normal;
}

@font-face {
font-family:"museo-sans-condensed";
src:url("https://use.typekit.net/af/6b043a/00000000000000007735995d/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("woff2"),url("https://use.typekit.net/af/6b043a/00000000000000007735995d/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("woff"),url("https://use.typekit.net/af/6b043a/00000000000000007735995d/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:900;font-stretch:normal;
}

/* Fonts End */

.imprint-step-content .c-tabs .c-tabs__btn {
    margin-right: 6px;
}
.imprint-step-content .c-tabs .c-tabs__btn:last-child {
    margin-right: 0;
}
.imprint-message__item.imprint-type__tab--active {
    color: #fff;
}
.c-d-between {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.imprint-types__upload-btn {
    color:#fff;
    width: 150px;
    padding: 7px 0;
    text-transform: uppercase;
    border: unset;
    cursor: pointer;
}
.start-new-imprint__tabs .imprint-message__item--btn:hover {
    cursor: pointer;
    text-decoration: underline;
}

.imprint-message__add {
    font-size: 16px;
    padding: 10px 0 10px 0;
    font-weight: 700;
    /*display: inline!important;*/
    position: relative;
    padding-left: 35px;
}

.imprint-message__add span.plus{
  position: absolute;
  top: 8px;
  font-size: 23px;
  padding-left: 0;
  left: 8px;
}

.imprint-message__add span.plus:hover{
  text-decoration: none;
}

.imprint-message__add:hover {
    cursor: pointer;
    text-decoration: underline;
}

.imprint-message__items {
    margin-top: 5px;
}
.imprint-text-bold {
    color: rgb(90, 90, 90);
    font-weight: 700;
}
.clist-table__col--title_line {
    display: flex;
    justify-content: space-between;
}
.clist-table__text-remove {
    color: red;
    font-size: 13px;
    cursor: pointer;
}
.clist-table__text-remove:hover {
    text-decoration: underline;
}
.clist-table.clist-table--titles {
    padding: 0;
    margin: 0;
}
.clist-table .clist-table__row {
    display: flex;
    flex-direction: row;
}

.c-full-width {
    width: 100%;
}

/* Start New Imprint */

.start-new-imprint input, .start-new-imprint select {
    height: 30px;
    border: 1px solid rgb(118,118,118);
}


.start-new-imprint__section, .imprint-location {
    padding-top: 0; /*padding-top: 15px;*/
    display: flex;
    flex-direction: column;
    text-align: left;
}

.start-new-imprint__label, .imprint-location label {
    font-family: 'museo-sans', sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: #5a5a5a;
    padding-bottom: 5px;
    display: block;
    text-align: left;
    padding-top: 15px;
}

.start-new-imprint__selector {
    min-height: 33px;
}

.imprint-location select {
    background: rgb(250 166 51 / 0%);
    border: 1px solid;
    border-radius: 8px;
    padding: 7px 10px!important;
    -webkit-appearance: menulist !important; /* override vuetify style */
    -moze-appearance: menulist !important; /* override vuetify style */
    appearance: menulist !important; /* override vuetify style */
}


.imprint-message__item--btn {
    color: #595959;
    padding: 5px 0px;
    border: 2px solid #d7d7d7;
    border-radius: 7px;
    display: inline-block;
    width: 100%;
    font: normal normal bold 14px/19px Open Sans;
    font-size: 14px;
    background-color: #fff;
    width: 32%;
}

.imprint-message__items {
    display: flex;
    justify-content: space-between;
}

.imprint-message__item--btn {
    color: #595959;
    padding: 5px 0px;
    border: 2px solid #d7d7d7;
    border-radius: 7px;
    display: inline-block;
    width: 100%;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    background-color: #fff;
    width: 32%;
}
.imprint-message__items {
    display: flex;
    justify-content: space-between;
}

.btns-wrapper.btns--vertical {
    padding: 20px 30px 10px 30px;
    display: flex;
    flex-direction: column;
}

.btns-wrapper.btns--vertical button {
    cursor: pointer;
    padding: 5px 0px;
    background-color: #fff;
    border: 2px solid #d7d7d7;
    border-radius: 7px;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    color: #707070;
    text-align: center;
    margin: 10px auto;
    width: 100%;
    font-weight: bold;
}

.btns-wrapper.btns--vertical button:hover{
  color: #fff;
}

.imprint-text {
    text-align: left;
    font-size: 12px;
    color: #5A5A5A;
    padding-top: 10px;
}


.imprint-step-content {
    padding: 15px;
}

.step-nav__list--imprint {
    margin: 0;
    padding: 15px;
    align-items: center;

}

.step-info-header .step-info-header__list {
    list-style: none;
    display: flex;
    justify-content: space-between;
    margin: 0;
    padding: 0;
    align-items: center;
    border-bottom: 1px solid rgb(89, 89, 89);
}

.imprint-bottom-info-text {
    font-size: 14px;
    padding: 10px 0;
    color: #5a5a5a;
    border-bottom: 1px solid #d7d7d7;
    border-top: 1px solid #d7d7d7;
}

.imprint-line {
    margin: 0 10px;
    border-top: 1px solid #d7d7d7;
}
.step-info-header__list .c-list__item {
    height: 40px;
    padding: 0 15px 0 15px;
    display: flex;
    align-items: center;
    color: #595959;
    font-size: 12px;
    width: 20%;
    justify-content: center;
    line-height: 14px;
    margin-bottom: 0;

}
.step-info-header__list .c-list__item.c-list__item-active {
    color: #fff;
    text-decoration: none;
    width: 60%;
}

.step-info-header__list .c-list__item.c-list__item-active.comdaBackgroundColor{
    width: 100%;
}

.step-nav .step-nav__list {
    list-style: none;
    display: flex;
    justify-content: space-between;
}

.c-btn--imprint-nav {
    display: flex;
    flex-direction: column;
    line-height: 16px;
}

.c-btn--imprint-nav-right {
    text-align: right;
}
.btn-disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.btn-disabled:hover {
    cursor: not-allowed;
}

.c-btn--imprint-nav.c-btn--imprint-nav--disabled {
    cursor: not-allowed;
}

.c-btn--imprint-nav.c-btn--imprint-nav--disabled span, .c-btn--imprint-nav.c-btn--imprint-nav--disabled span:hover {
    color: rgb(90,90,90);
    cursor: not-allowed;
}

.c-btn--imprint-nav.c-btn--imprint-nav--disabled span:hover, .c-btn--imprint-nav.c-btn--imprint-nav--disabled:hover span {
    text-decoration: none;
    cursor: not-allowed;
}

.c-btn--imprint-nav-left {
    text-align: left;
}
.imprint-nav__text--main {
    font-weight: bold;
    font-size:14px;
}

.imprint-nav__text--sub {
    font-size: 12px;
    font-family: "Open Sans", sans-serif;
}

.c-btn--imprint-nav:hover span {
 text-decoration: underline;
 cursor: pointer;
}

.imprint-nav-wrapper {
    border: 1px solid rgb(89, 89, 89);
    max-width: 700px;
}

ul li.step-nav__item {
    margin-bottom: 0;
}

.step-nav__item.step-nav__item--next, .step-nav__item.step-nav__item--prev {
    display: flex;
    align-items: center;
}
.step-nav__item.step-nav__item--next::after {
    content: '>>';
    font-size: 12px;
    font-weight: 600;
    margin-left: 5px;
}

.imprint-nav-next--disabled .step-nav__item.step-nav__item--next::after {
    color: rgb(90, 90, 90);
    cursor: not-allowed;
}

.step-nav__item.step-nav__item--prev::before {
    content: '<<';
    font-size: 12px;
    font-weight: 600;
    margin-right: 5px;
}

.clist-style--none {
    list-style-type: none;
}

.c-btn.c-btn--add-to-cart {
    color: #fff;
    padding: 8px 16px;
    font-weight: 800;
}

.c-btn.c-btn--add-to-cart:hover {
    background-color: #2dbe71;
}

.btns-wrapper.btns--vertical p{
  font: normal normal bold 14px/19px Open Sans;
  color: #252525;
}

#section-image-with-text-c .imprint-message__add{
  /*float: left;*/
  text-align: left;
}

.btns-wrapper.btns--vertical p{
  margin: 5px 0;
}
.imprint-message__add.add-color{
  max-width: 185px;
}

.step-nav__list span.imprint-nav__text:focus{
  color: #5c5c5c!important;
  outline: none;
}

.step-nav__list span.imprint-nav__text:active{
  color: #009444!important;
}

.modal-btn {
    background-color: #0072BC;
    color: white;
    font: normal normal bold 12px / 17px Open Sans;
    font-size: 11px;
    padding: 10px 10px;
    border: 1px solid #0054a3;
    border-radius: 4px;
    cursor: pointer;
}
.modal-btn:active, .modal-btn:hover {
    outline: 0;
}
.modal-btn:focus {
    color: #040404;
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.42);
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity 0.3s ease;
}

.modal-container {
    height: auto;
    /*background-color: black;*/
    border-radius: 25px;
    /*border: 2px solid #707070;*/
    width: 95%;
    overflow: hidden;
    position: relative;
    max-width: 510px;
    /*background-image: url('../assets/how_to_order_image.png');*/
    /*background-size: cover;*/
    /*background-repeat: no-repeat;*/
    /*background-position: center;*/
}

.modal-close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
    color: white;
    font-size: 20px;
    font-weight: 500;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.availability-status {
    color: #11B400;
    text-transform: none;
    font-style: italic;
    margin: 5px 0;
    font-size: 13px;
    font-family: "Open Sans", "Helvetica Neue", Verdana, Arial, sans-serif;
    text-align: left;
}

#section-image-with-text-c .comda{
    font-family: "Open Sans", sans-serif;
}

.price-matrix__col.price-matrix__col--price{
    font-size: 12px;
    font-weight: 700;
    font-family: 'museo-sans', sans-serif;
}
.comda .price-matrix__col.price-matrix__col--price{
    font-weight: 800;
    font-size: 15px;
    font-family: 'Montserrat', 'Helvetica Neue', Verdana, Arial, sans-serif;
}

.comda a.bundle-butons__item.bundle-butons__item{
    background-color: #0054a3!important;
}

.comda .step-nav__list span.imprint-nav__text:active,
.comda .step-nav__list span.imprint-nav__text,
.comda .step-nav__item.step-nav__item--prev:before,
.comda .step-nav__item.step-nav__item--next:after{
    color:#0072BC !important;
}

.mobile-title.c-text-card__title{
    display: none;
}

@media only screen and (max-width: 1024px) {

    .comda .imprint-nav__text--sub{
     font-size:12px ;
    }
}

@media only screen and (max-width: 768px) {
    .bundle-butons.bundle-butons-wrapper{
        display: block;
    }
    .bundle-butons-wrapper .bundle-butons__item.bundle-butons__item--qty{
        display: flex;
    }
    .bundle-butons-wrapper .bundle-butons__item{
        display: block;
        width: 100%;
    }

    .arrow-left:before, .arrow-right:after{
        position: static;
        margin-bottom: 1px;
    }

    .img-preview-section, .color-size-section {
        width: 100%;
    }

    .color-size-main-wrapper {
        flex-direction: column;
    }


    .color-size-section .size-row .controls-container {
        width: 35px;
        height: 30px;
        min-height: 30px;
        max-height: 30px;
    }

    .color-size-section .size-row .size-row__input {
        width: 65px;
        height: 30px;
        max-width: 65px;
        min-height: 30px;
    }

    .color-size-section .size-row .qty-wrap {
        width: 138px;
    }

    .color-size-section .size-row {
        justify-content: start;
    }

    .color-picker-btn {
        width: 18.4px;
        height: 18.4px;
    }

    .color-size-section .size-row .qty-wrap {
        margin: 5px 0;
    }

    .img-preview-background-wrapper {
        width: 100%;
        border: 1px solid #eee;
        max-width: 250px;
        margin: 0 auto;
    }
    div.mobile-title{
        font-size: 20px;
        font-weight: 700;
        text-align: left;
    }
    .mobile-title.c-text-card__title{
        display: block;
        color: #009444;
        padding: 20px 0 5px 0;
        font-family: 'museo-sans', sans-serif;
    }

    .comda .mobile-title.c-text-card__title{
        display: block;
        font-family: 'Open Sans', serif;
        color: #0054a3;
        padding: 20px 0 5px 0;
    }

}

@media only screen and (max-width: 460px) {
    .comda .price-matrix__col.price-matrix__col--price{
        font-size: 12px;
    }
    .modal-close-btn {
        top: 10px;
        right: 20px;
    }
}

@media screen and (max-width: 440px) {
    .step-info-header__list .c-list__item {
        width: 25%;
        padding: 0;
    }
    .step-info-header__list .c-list__item.c-list__item-active {
        width: 60%;
        padding: 0;
    }
}
@media only screen and (max-width: 340px) {
    .modal-close-btn {
        top: 5px;
    }
}

@media only screen and (max-width: 360px) {
    .price-matrix.price-matrix--table .price-matrix__line .price-matrix__col.price-matrix__col--price, .retail-price .price-matrix__col.price-matrix__col--price {
        font-size: 9px;
    }

    .step-info-header__list .c-list__item,
    .step-info-header__list .c-list__item.c-list__item-active {
        width: 100%;
        padding-left: 20px;
        justify-content: start;
    }

    .step-info-header .step-info-header__list{
        flex-direction: column;
    }

}

</style>